"use client";

import { useEffect, useState } from "react";
import { useLocationState } from "@rangojs/router/client";
import { CartFlash } from "../location-states.js";

export function CartFlashBanner() {
  const flash = useLocationState(CartFlash);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (flash) {
      setVisible(true);
      const timer = setTimeout(() => setVisible(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [flash]);

  if (!visible || !flash) return null;

  return (
    <div className="bg-green-50 px-6 py-3 text-center text-sm font-medium text-green-800 transition-opacity">
      {flash.text}
    </div>
  );
}
